import React from "react";
import Helmet from "react-helmet";
import Navbar from "./navbar";
import Footer from "./footer";
import { Link } from "gatsby";

export default function Layout({ children, title, hasSubNav }) {
  return (
    <>
      <Helmet lang={"en"} title={`${title ? title + " | " : ""} DripStat `}>
        <meta name="viewport" content="width=1344" />
        <meta name="description" content="Next Gen APM, Infrastructure and Kubernetes Monitoring" />
      </Helmet>
      <div id="topBanner">
        <div className="container">
          <div className="columns">
            <div className="column has-text-centered">
              <Link to="/products/kubernetes/">Introducing Dripstat Kubernetes Monitoring</Link>
            </div>
          </div>
        </div>
      </div>
      <Navbar hasSubNav={hasSubNav} />
      {children}
      <Footer />
    </>
  );
}
